import React, { useEffect } from 'react';
import Header from '../../../Header';
import Footer from '../../../Footer';
import Banner from '../../Banner';
import { Link, useLocation } from 'react-router-dom';

const Cerez: React.FC = () => {
  const location = useLocation();
  const language = location.pathname.startsWith('/en') ? 'en' : 'tr';
  const lang: 'en' | 'tr' = language;

  const setLanguage = (newLang: 'en' | 'tr') => {
    let newPath = location.pathname;
    if (newLang === 'en' && !newPath.startsWith('/en')) {
      newPath = '/en' + (newPath.startsWith('/tr') ? newPath.slice(3) : newPath);
    } else if (newLang === 'tr' && !newPath.startsWith('/tr')) {
      newPath = '/tr' + (newPath.startsWith('/en') ? newPath.slice(3) : newPath);
    }
    window.location.href = newPath;
  };

  const breadcrumb = (
    <>
      <Link to={`/${lang}`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Ana Sayfa' : 'Home'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Sertifikasyon ve Dökümantasyon' : 'Certification & Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <Link to={`/${lang}/about/certification/documents`} className="text-gray-400 font-bold">{lang === 'tr' ? 'Dökümantasyon' : 'Documentation'}</Link>
      <span className="text-gray-400 font-bold">/</span>
      <span className="text-white font-bold">{lang === 'tr' ? 'Çerez Politikası' : 'Cookie Policy'}</span>
    </>
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header language={lang} setLanguage={setLanguage} />
      <Banner
        title={lang === 'tr' ? 'Çerez Politikası' : 'Cookie Policy'}
        description={lang === 'tr' ? 'Web sitemizde kullanılan çerezler ve kullanım esasları.' : 'Cookies used on our website and terms of use.'}
        breadcrumb={breadcrumb}
      />
      <div className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          {lang === 'tr' ? (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Çerez Nedir?</h3>
                <p className="text-gray-700 leading-relaxed">Çerezler, web sitemizi ziyaret ettiğinizde tarayıcınıza kaydedilen küçük metin dosyalarıdır. Bu dosyalar, sitemizin düzgün çalışmasını sağlamak, kullanıcı deneyimini geliştirmek ve site trafiğini analiz etmek amacıyla kullanılmaktadır.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Kullandığımız Çerez Türleri</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>Zorunlu Çerezler:</strong> Sitenin temel işlevleri için gereklidir; bu çerezler devre dışı bırakılamaz.</li>
                  <li><strong>Analitik Çerezler:</strong> Sitemizin nasıl kullanıldığını anlamak için Google Analytics gibi araçlar aracılığıyla kullanılır. Elde edilen veriler anonimleştirilmiş olarak işlenir.</li>
                  <li><strong>Fonksiyonel Çerezler:</strong> Dil tercihiniz ve oturum bilgileriniz gibi ayarlarınızı hatırlamak için kullanılır.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Çerezleri Nasıl Kontrol Edebilirsiniz?</h3>
                <p className="text-gray-700 leading-relaxed">Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilir veya silebilirsiniz. Ancak bazı çerezlerin engellenmesi, sitemizin belirli özelliklerinin düzgün çalışmamasına yol açabilir. Tarayıcı başına çerez yönetimi için ilgili tarayıcının yardım sayfasını inceleyebilirsiniz.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Üçüncü Taraf Çerezleri</h3>
                <p className="text-gray-700 leading-relaxed">Sitemiz, Google Analytics gibi üçüncü taraf hizmet sağlayıcıların çerezlerini kullanabilir. Bu sağlayıcıların gizlilik politikaları kendi web sitelerinde yayınlanmaktadır. CG Teknoloji, üçüncü taraf çerezlerin içeriğinden sorumlu değildir.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Politika Güncellemeleri</h3>
                <p className="text-gray-700 leading-relaxed">Bu politika zaman zaman güncellenebilir. Önemli değişiklikler olması halinde sitemiz üzerinden bilgilendirme yapılacaktır. Güncel politikaya her zaman bu sayfa üzerinden ulaşabilirsiniz.</p>
              </section>
            </div>
          ) : (
            <div className="space-y-8">
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">What Are Cookies?</h3>
                <p className="text-gray-700 leading-relaxed">Cookies are small text files saved to your browser when you visit our website. They are used to ensure the site functions properly, enhance user experience, and analyze website traffic.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Types of Cookies We Use</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
                  <li><strong>Essential Cookies:</strong> Required for the basic functions of the site; these cookies cannot be disabled.</li>
                  <li><strong>Analytical Cookies:</strong> Used through tools such as Google Analytics to understand how our site is used. The data collected is processed in anonymized form.</li>
                  <li><strong>Functional Cookies:</strong> Used to remember your settings such as language preference and session information.</li>
                </ul>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">How Can You Control Cookies?</h3>
                <p className="text-gray-700 leading-relaxed">You can disable or delete cookies from your browser settings. However, blocking certain cookies may cause some features of our site to not function properly. Please refer to your browser's help page for per-browser cookie management.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Third-Party Cookies</h3>
                <p className="text-gray-700 leading-relaxed">Our site may use cookies from third-party service providers such as Google Analytics. The privacy policies of these providers are published on their own websites. CG Teknoloji is not responsible for the content of third-party cookies.</p>
              </section>
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Policy Updates</h3>
                <p className="text-gray-700 leading-relaxed">This policy may be updated from time to time. In the event of significant changes, notification will be provided through our website. You can always access the current policy on this page.</p>
              </section>
            </div>
          )}
        </div>
      </div>
      <Footer language={lang} />
    </div>
  );
};

export default Cerez; 